import { useMutation } from 'react-query'
import useApi from '../../../hooks/use-api'
import useCacheKeys from '../../../hooks/use-cache-keys'
import useCache from '../../../hooks/use-cache'
import useToasts from '../../../hooks/use-toasts'

const useCreateDiscussion = ({
    topic,
    content,
    users = [],
    onSuccess = () => {}
}) => {
    const { toastSuccess } = useToasts({
        successMessage: 'Message sent!',
        onSuccess
    })
    const { toastError } = useToasts({ errorMessage: 'Error sending message.' })
    const cacheKeys = useCacheKeys()
    const { clearCache } = useCache({ key: cacheKeys.DISCUSSIONS, onReload: toastSuccess })
    const { api, endpoints } = useApi()
    const [ createDiscussion, { isLoading }] = useMutation(
        () => api.post(endpoints.discussions, { topic, content, users}),
        {
            onSuccess: clearCache,
            onError: toastError
        }
    )

    return {
        isCreatingDiscussion: isLoading,
        createDiscussion
    }
}

export default useCreateDiscussion
